import React, { type ComponentType, lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { storeManagementMultiScopeAccessControl } from '../access-control/onboardingAccess.configuration'

const OnboardingStoreManagementPartnerScopedPage = lazy(
  () =>
    import(
      /* webpackChunkName: "OnboardingStoreManagementPartnerScopedPage" */
      '../pages/store-management/OnboardingStoreManagementPartnerScopedPage'
    )
)
const OnboardingRequestNewStorePage = lazy(
  () =>
    import(
      /* webpackChunkName: "OnboardingRequestNewStorePage" */
      '../pages/request-new-store/OnboardingRequestNewStorePage'
    )
)

export const onboardingPartnerScopedRouter = (
  <DomainRoute route="onboarding-partner-scoped">
    <DashSwitch>
      <DomainRoute
        exact
        route="onboarding-store-management-partner-scoped"
        tool="store-management-dashboard-tool"
        component={OnboardingStoreManagementPartnerScopedPage as ComponentType<any>}
        accessControl={storeManagementMultiScopeAccessControl}
      />
      <DomainRoute
        exact
        route="onboarding-request-new-store-partner-scoped"
        tool="store-management-dashboard-tool"
        component={OnboardingRequestNewStorePage as ComponentType<any>}
        accessControl={storeManagementMultiScopeAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
